import { FORM_TYPES } from '../consts';
import { getFlowTypePayload } from './getFlowType';

export const emailCheck = async (email: string) => {
  try {
    const { formType } = window.LPFormData;

    const response = await fetch('/lpapi/trial/EmailCheck', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: email,
        sku: FORM_TYPES.BUSINESSTRIAL,
        flowType: getFlowTypePayload(formType),
      }),
    });

    const data = await response.json();
    return data;
  } catch (error) {
    return { success: false, code: error?.response?.data?.code || 0 };
  }
};
